import React from "react";
import { FaCheck } from "react-icons/fa";
import DOMPurify from "dompurify";

const DigitalBankCard = ({ title, subtitle, items }) => {
  const sanitizeOptions = {
    ALLOWED_TAGS: ["span", "strong", "b", "i", "u", "em"],
    ALLOWED_ATTR: ["class"],
  };

  const sanitizedTitle = DOMPurify.sanitize(title, sanitizeOptions);

  return (
    <div className="digital-bank-card-wrapper">
      <div className="digital-bank-card">
        <br />
        <h1 dangerouslySetInnerHTML={{ __html: sanitizedTitle }} />
        <p>{subtitle}</p>
        <br />
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <FaCheck className="check-icon" />
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.text, sanitizeOptions),
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DigitalBankCard;
